import { Lightning, Utils, Log, Router, AppData } from '@lightningjs/sdk';
import { Column, Row } from '@lightningjs/ui-components';
import Thumb from './Thumb';
import { AppSetup } from '../../lib/app-setup';


export default class MoreInfoUI extends Lightning.Component {
    static override _template() {
        return {
            w: 1920,
            h: 1080,
            rect: true,
            color: 0xFF000000,
            clipping: true,
            collision:true,
            Background: {
                w: 1920,
                h: 1080,
            },
            TitleWrapper: {
                x: 190,
                y: 40,
                h: 50,
                w: (w) => w - 250,
                collision:true,
                flex: { direction: 'row'},
                // BackButton: {
                //     h: 40,
                //     w: 60,
                //     y: 10,
                //     paddingRight: 20,
                //     alpha: 0.7,
                //     collision:true,
                //     ImgContainer: {
                //         h: 40,
                //         w: 40,
                //         texture: {
                //             src: Utils.asset('images/ico-back.png'),
                //             resizeMode: {
                //                 h: 40,
                //                 w: 40,
                //                 type: 'contain',
                //             },
                //             type: Lightning.textures.ImageTexture
                //         }
                //     }
                // },
                Title: {
                    h: 50,
                    w: 0,
                    text: { text: 'MORE', fontSize: 45, textColor: 0xffffffff },
                }
            },
            MenuWrapper: {
                y: 200,
                x: 190,
                w: (w) => w - 250,
                h: 860,
                clipping: true,
                collision:true,
                type: Column,
                plinko: true,
                style: { itemSpacing: 40 },
                items: []
            }
        }
    }

    override _firstActive() {
        const { appConfig, appState } = AppData as AppSetup;
        const appApiConfig = appState?.getAppApiConfig();
        if (appApiConfig?.appBrandConfig?.iptv_background) {
            this.patch({
                Background: {
                    src: appApiConfig.appBrandConfig.iptv_background,
                },
            });
        }
        this._updateMoreItems();
    }

    _handleClick(target) {
        Log.info('MoreInfoUI _handleClick:', target)
        if(target.ref === 'BackButton') {
            Promise.resolve().then(() => {
                this.fireAncestors('$handleBack');
            })            
            return true;
        }
        return false
    }

    _updateMoreItems() {
        Log.info('_updateMoreItems', this.moreOptions)
        const moreOptions = this.moreOptions || [];
        const items = moreOptions.map((row, rowIndex) => {
            return {  
                type: Row,
                autoResizeHeight: true,
                style: { itemSpacing: 40 },
                items: row.map((item, itemIndex) => ({
                    w: 536,
                    h: 326,
                    type: Thumb,
                    collision:true,
                    icon: item.icon,
                    title: item.content.toUpperCase(),
                    rowIndex,
                    itemIndex
                }))
            };
        });
        this.patch({ MenuWrapper: { items: items } });

        const firstItem = moreOptions[0]?.[0]
        if (firstItem) {
            const { platform } = AppData as AppSetup
            platform?.textToSpeach(`More, ${firstItem.content.toUpperCase()}`)
        }
    }
     
    // Handle tile click event from Thumb
    $onTileClicked({ rowIndex, itemIndex }) {
        this.fireAncestors('$enterContent', { rowIndex, itemIndex });
    }

    override _getFocused() {
        return this.tag('MenuWrapper')
    }
    // override _handleLeft() {
    //     Log.info('AboutWidget:', '_handleLeft fired')
    //     Router.focusWidget('Menu')
    //     this.isMenuFocused = true;
    //     return true
    // }
    // override _handleLeft(){
    //     Log.info('AboutWidget:  MoreInfoUI _handleLeft fired')
    //     return true
    // }
    // override _handleBack(e: KeyboardEvent): boolean | void {
    //     Log.info('AboutWidget: _handleBack fired')
    //     Router.focusWidget('Menu')
    //     return true
    // }
    override _handleDown(){
        Log.info('AboutWidget:  MoreInfoUI _handleDown fired')
        return true
    }
    override _handleUp(){
        Log.info('AboutWidget:  MoreInfoUI _handleUp fired')
        return true
    }
    override _handleRight(){
        Log.info('AboutWidget:  MoreInfoUI _handleRight fired')
        return true
    }

    $handleHover(target) {
        Log.info('MoreInfoUI $handleHover:', target)
        this.tag('MenuWrapper').selectedIndex = target.rowIndex
        this.tag('MenuWrapper').items[target.rowIndex].selectedIndex = target.itemIndex
        // this._focus()
        // this.fireAncestors('$handleHover', target)
        return true
    }

    
    

}